module.exports = __webpack_public_path__ + "static/media/CBN-Overview.33d03f28.gif";